import t from "./FindAnythingButton.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const n = /* @__PURE__ */ o(t, [["__scopeId", "data-v-1d0a72ff"]]);
export {
  n as default
};
